// Used to prevent circle dependency.

export const headerHeight = '8rem';
export const headerPaddingX = '3rem';
